import React from "react";
import { twMerge } from "tailwind-merge";
import { getClasses } from "../helpers";
import { Tooltip } from "@/app/(components)/Basic/Tooltip";
import { QuestRecurringInterval } from "@/api/quests/types";
import { getRecurringTooltipMsg } from "../helpers";

export interface Props {
  color: string;
  completedCount: number;
  recurringInterval: QuestRecurringInterval;
  completed: boolean;
}

const CompleteQuestCount = ({
  color,
  completedCount,
  recurringInterval,
  completed,
}: Props) => {
  const { bgClass, textHoverClass } = getClasses(color);

  return (
    <Tooltip
      text={getRecurringTooltipMsg(
        recurringInterval,
        completedCount,
        completed,
      )}
      tooltipClassName="w-40"
      position={["center", "bottom"]}
    >
      <div
        className={twMerge(
          bgClass,
          "rounded-full h-10 w-10 flex items-center justify-center group-hover:bg-white endemic:bg-black",
        )}
      >
        <span
          className={twMerge(
            `text-[15px] text-white endemic:group-hover:text-black font-semibold`,
            textHoverClass,
          )}
        >
          {completedCount}x
        </span>
      </div>
    </Tooltip>
  );
};

export default CompleteQuestCount;
